import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import PlaceLayouts from '../../../models/interfaces/layout/PlaceLayouts';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchPlaceLayouts, FetchPlaceLayoutsPayload, placeLayoutsFetched, placeLayoutsFetchFailed } from '../../actions/place/fetchPlaceLayouts';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchPlaceStateSaga({ payload }: Action<FetchPlaceLayoutsPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState, placeUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getPlaceLayouts, token, { placeUuid });
  const { placeLayouts, error } = response;
  if (!error) {
    const responsePayload = {
      placeLayouts: placeLayouts as PlaceLayouts,
      timestamp,
    };
    const responseAction = placeLayoutsFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = placeLayoutsFetchFailed({ timestamp, placeUuid });
    yield put(responseAction);
  }
}

export default function* watchFetchPlaceStateSaga() {
  yield takeEvery(fetchPlaceLayouts, fetchPlaceStateSaga);
}
